<div mat-dialog-title>Hitta dokument</div>
<div class="content">
  <mat-form-field>
    <input (keydown.enter)="findPackage()"
           (input)="message.set('')"
           [formControl]="sub"
           matInput placeholder="Sök personnummer"
           spbPersonnummerValidator>
  </mat-form-field>
  @if (message()) {
    <p class="doc-not-found">{{ message() }}</p>
  }
</div>

<mat-dialog-actions>
  <button matDialogClose="cancel" matButton="outlined">Stäng</button>
  <button (click)="findPackage()" [disabled]="sub.invalid"
          matButton="filled">Sök
  </button>
</mat-dialog-actions>